<template>
  <div>
    <div class="breadcrumb">缓存刷新</div>
    <div>
      <el-form ref="form" label-width="150px" style="margin:50px 30px">
        <el-form-item label="角色缓存">
          <el-button type="primary" @click="initMenuRedis">刷新</el-button>
        </el-form-item>
        <el-form-item label="产品缓存">
          <el-button type="primary" @click="pms">刷新</el-button>
        </el-form-item>
        <el-form-item label="同步所有特殊价格">
          <el-button type="primary" @click="saveSpecialToEs">刷新</el-button>
        </el-form-item>
        <el-form-item label="同步所有类">
          <el-button type="primary" @click="syncCategoryToEs">刷新</el-button>
        </el-form-item>
        <el-form-item label="同步所有合成尺寸组">
          <el-button type="primary" @click="syncComposeSizeGroupToEs">刷新</el-button>
        </el-form-item>
        <el-form-item label="同步所有合成尺寸">
          <el-button type="primary" @click="syncComposeSizeToEs">刷新</el-button>
        </el-form-item>
        <el-form-item label="同步所有属性">
          <el-button type="primary" @click="syncDictToEs">刷新</el-button>
        </el-form-item>
        <el-form-item label="同步所有页面名称">
          <el-button type="primary" @click="syncSpuPageNameToEs">刷新</el-button>
        </el-form-item>
        <el-form-item label="同步所有主题">
          <el-button type="primary" @click="syncThemeToEs">刷新</el-button>
        </el-form-item>
        <el-form-item label="同步所有收藏">
          <el-button type="primary" @click="syncSpuFavorite">刷新</el-button>
        </el-form-item>
        <el-form-item label="同步出血">
          <el-button type="primary" @click="syncMqSpuBleed">刷新</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { initMenuRedis, esSyncSpuToEs, syncThemeToEs, saveSpecialToEs, syncSpuFavorite, syncMqSpuBleed, syncComposeSizeGroupToEs, syncCategoryToEs, syncComposeSizeToEs, syncDictToEs, syncSpuPageNameToEs } from '@/api/sync.js'
export default {
  methods: {
    initMenuRedis () {
      initMenuRedis().then(res => res.data.success && this.$message.success('刷新成功'))
    },
    pms () {
      esSyncSpuToEs().then(res => res.data.success && this.$message.success('刷新成功'))
    },
    saveSpecialToEs () {
      saveSpecialToEs().then(res => res.data.success && this.$message.success('刷新成功'))
    },
    syncComposeSizeGroupToEs () {
      syncComposeSizeGroupToEs().then(res => res.data.success && this.$message.success('刷新成功'))
    },
    syncCategoryToEs () {
      syncCategoryToEs().then(res => res.data.success && this.$message.success('刷新成功'))
    },
    syncComposeSizeToEs () {
      syncComposeSizeToEs().then(res => res.data.success && this.$message.success('刷新成功'))
    },
    syncDictToEs () {
      syncDictToEs().then(res => res.data.success && this.$message.success('刷新成功'))
    },
    syncSpuPageNameToEs () {
      syncSpuPageNameToEs().then(res => res.data.success && this.$message.success('刷新成功'))
    },
    syncSpuFavorite () {
      syncSpuFavorite().then(res => res.data.success && this.$message.success('刷新成功'))
    },
    syncMqSpuBleed () {
      syncMqSpuBleed().then(res => res.data.success && this.$message.success('刷新成功'))
    },
    syncThemeToEs () {
      syncThemeToEs().then(res => res.data.success && this.$message.success('刷新成功'))
    }
  }
}
</script>
<style></style>
